const highlightClassName = "inPageHighlight";
const activeClassName = "active";
const exclusiveTags = [
  "script",
  "style",
  "noscript",
  "head",
  "xref",
];

function isVisible(node) {
  const parent = node.parentElement;
  if (!parent) return false;

  const style = window.getComputedStyle(parent);
  return (
    style.display !== "none" &&
    style.visibility !== "hidden" &&
    style.visibility !== "collapse" &&
    parent.offsetParent !== null
  );
}

function isExcludedTag(node) {
  const tag = node.parentElement?.tagName?.toLowerCase();
  return exclusiveTags.includes(tag);
}

export function highlightTextMatches(rootNode, searchTerm) {
  if (!searchTerm) return;
  let counter = 0;

  const walk = document.createTreeWalker(
    rootNode,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        if (
          node.textContent.trim() === "" ||
          isExcludedTag(node) ||
          !isVisible(node)
        ) {
          return NodeFilter.FILTER_REJECT;
        } else {
          return NodeFilter.FILTER_ACCEPT;
        }
      },
    },
    false,
  );

  const nodesToHighlight = [];
  while (walk.nextNode()) {
    nodesToHighlight.push(walk.currentNode);
  }

  nodesToHighlight.forEach((textNode) => {
    let modTextNode = modifyTopicHeader(textNode);
    const text = modTextNode.nodeValue;
    const textLower = text.toLowerCase();
    let matchIndex;
    let lastIndex = 0;
    const fragment = document.createDocumentFragment();

    while (
      (matchIndex = textLower.indexOf(searchTerm.toLowerCase(), lastIndex)) !==
      -1
    ) {
      if (matchIndex > lastIndex) {
        fragment.appendChild(
          document.createTextNode(text.substring(lastIndex, matchIndex)),
        );
      }

      const span = document.createElement("span");
      span.className = highlightClassName;
      span.dataset.index = counter++;
      span.appendChild(
        document.createTextNode(
          text.substring(matchIndex, matchIndex + searchTerm.length),
        ),
      );
      fragment.appendChild(span);

      lastIndex = matchIndex + searchTerm.length;
    }

    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
    }

    if (fragment.childNodes.length > 0) {
      modTextNode.parentNode.replaceChild(fragment, modTextNode);
    }
  });
  return counter;
}

/**
 * Wraps the text content of topic headers (`<h2 class="topicontainer">`) in `<span>` tags
 * to ensure consistent highlighting styles during "Find in Page" operations.
 *
 * @example
 * // Before:
 * <h2 class="topicontainer">Thyroid Disorders</h2>
 * // After:
 * <h2 class="topicontainer"><span>Thyroid Disorders</span></h2>
 */
const modifyTopicHeader = (textNode) => {
  const h2 = textNode.parentNode;
  if (h2.nodeName === "H2" && h2.classList.contains("topicontainer")) {
    const span = document.createElement("span");
    span.textContent = textNode.textContent.trim();
    textNode.replaceWith(span);

    return span.firstChild;
  }
  return textNode;
};

/**
 * This function is to clear all highlight span when there is a change in search term
 * @param rootNode
 */
export function clearHighlights(rootNode) {
  const highlights = rootNode.querySelectorAll(`span.${highlightClassName}`);
  highlights.forEach((span) => {
    const parent = span.parentNode;
    parent.replaceChild(document.createTextNode(span.textContent), span);
    parent.normalize();
  });
}

export const scrollToTop = (rootNode) => {
  rootNode.scrollIntoView({
    behavior: "smooth",
    block: "start",
    inline: "nearest",
  });
};

export const scrollToMatch = (index) => {
  const allHighlights = document.querySelectorAll(
    `.${highlightClassName}.${activeClassName}`,
  );

  allHighlights.forEach((el) => el.classList.remove(activeClassName));
  const el = document.querySelector(
    `.${highlightClassName}[data-index="${index}"]`,
  );
  if (!el) {
    console.warn(`No highlight found at index ${index}`);
    return;
  }
  el.classList.add(activeClassName);
  el.scrollIntoView({ behavior: "smooth", block: "center" });
  el.focus?.();
};
